import { useContext } from 'react';
import type { Context } from 'react';

import type { Editable } from '../../../types/editable.type';

import { DocumentEditorContext } from '..';
import type { DocumentEditorData } from '..';

export const useDocumentEditorContext = <E extends Editable>() =>
  useContext<DocumentEditorData<E>>(
    DocumentEditorContext as unknown as Context<DocumentEditorData<E>>,
  );
